export default "__VITE_ASSET__izW7boCb__"